// Test IDs for the Zyberzing CRM. All values kebab-case.

export const NAV = {
    dashboard: "nav-dashboard-link",
    leads: "nav-leads-link",
    pipeline: "nav-pipeline-link",
    discovery: "nav-discovery-link",
    followups: "nav-followups-link",
    proposals: "nav-proposals-link",
    projects: "nav-projects-link",
    activities: "nav-activities-link",
    contacts: "nav-contacts-link",
    clients: "nav-clients-link",
    invoices: "nav-invoices-link",
    users: "nav-users-link",
    themeToggle: "nav-theme-toggle",
    logoutButton: "nav-logout-button",
    globalSearch: "nav-global-search-input",
    globalSearchResult: "nav-global-search-result",
};

export const DASHBOARD = {
    root: "dashboard-root",
    totalLeads: "dashboard-stat-total-leads",
    followUps: "dashboard-stat-followups",
    dealsWon: "dashboard-stat-deals-won",
    activeProjects: "dashboard-stat-active-projects",
    revenue: "dashboard-stat-revenue",
    recentActivities: "dashboard-recent-activities",
    pipelineChart: "dashboard-pipeline-chart",
    todayFollowups: "dashboard-today-followups",
    todayTasks: "dashboard-today-tasks",
    recommendations: "dashboard-recommendations",
    recommendationsRefresh: "dashboard-recommendations-refresh",
    recommendationItem: "dashboard-recommendation-item",
    overdueBadge: "dashboard-overdue-badge",
    followupRow: "dashboard-followup-row",
    actionEmail: "dashboard-action-email",
    actionComplete: "dashboard-action-complete",
    actionReschedule: "dashboard-action-reschedule",
    actionView: "dashboard-action-view",
    rescheduleDate: "dashboard-reschedule-date",
    rescheduleSubmit: "dashboard-reschedule-submit",
    filterPrefix: "dashboard-filter-",
    filterPriority: "dashboard-filter-priority",
    filterAssigned: "dashboard-filter-assigned",
    taskPrefix: "dashboard-task-",
    notifBell: "dashboard-notif-bell",
    actionSkip: "dashboard-action-skip",
    actionSendEmail: "dashboard-action-send-email",
    emailDialog: "dashboard-email-dialog",
    emailDialogSubject: "dashboard-email-dialog-subject",
    emailDialogBody: "dashboard-email-dialog-body",
    emailDialogSend: "dashboard-email-dialog-send",
    notifEnable: "dashboard-notif-enable",
};

export const NAV_EXTRA = {
    settings: "nav-settings-link",
};

export const LEADS = {
    root: "leads-root",
    createButton: "leads-create-button",
    tableRow: "leads-table-row",
    searchInput: "leads-search-input",
    statusFilter: "leads-status-filter",
    priorityFilter: "leads-priority-filter",
    sourceFilter: "leads-source-filter",
    pagePrev: "leads-page-prev",
    pageNext: "leads-page-next",
    detailDrawer: "leads-detail-drawer",
    convertButton: "leads-convert-button",
    deleteButton: "leads-delete-button",
    formCompany: "lead-form-company",
    formCompanyEmail: "lead-form-company-email",
    formClientName: "lead-form-client-name",
    formEmail: "lead-form-email",
    formPhone: "lead-form-phone",
    formWebsite: "lead-form-website",
    formSource: "lead-form-source",
    formService: "lead-form-service",
    formStatus: "lead-form-status",
    formPriority: "lead-form-priority",
    formValue: "lead-form-value",
    formAssigned: "lead-form-assigned",
    formNotes: "lead-form-notes",
    formSubmit: "lead-form-submit",
};

export const CONTACTS = {
    root: "contacts-root",
    createButton: "contacts-create-button",
    exportButton: "contacts-export-button",
    row: "contacts-row",
};

export const CLIENTS = {
    root: "clients-root",
    row: "clients-row",
};

export const INVOICES = {
    root: "invoices-root",
    createButton: "invoices-create-button",
    row: "invoices-row",
};

export const USERS = {
    root: "users-root",
    row: "users-row",
};

export const PIPELINE = {
    root: "pipeline-root",
    column: "pipeline-column",
    card: "pipeline-card",
};

export const FOLLOWUPS = {
    root: "followups-root",
    createButton: "followups-create-button",
    row: "followups-row",
    completeButton: "followups-complete-button",
};

export const PROPOSALS = {
    root: "proposals-root",
    createButton: "proposals-create-button",
    row: "proposals-row",
    uploadInput: "proposals-upload-input",
};

export const PROJECTS = {
    root: "projects-root",
    createButton: "projects-create-button",
    card: "projects-card",
    detailButton: "projects-detail-button",
};

export const ACTIVITIES = {
    root: "activities-root",
    row: "activities-row",
};

export const FOLLOWUP_SETTINGS = {
    root: "followup-settings-root",
    enabledToggle: "followup-settings-enabled",
    defaultTime: "followup-settings-default-time",
    defaultReminder: "followup-settings-default-reminder",
    addStep: "followup-settings-add-step",
    save: "followup-settings-save",
    restore: "followup-settings-restore",
    stepPrefix: "followup-settings-step-",
    stepStageName: "followup-settings-step-stage-",
    stepDays: "followup-settings-step-days-",
    stepSubject: "followup-settings-step-subject-",
    stepBody: "followup-settings-step-body-",
    stepRemove: "followup-settings-step-remove-",
};

export const DISCOVERY = {
    root: "discovery-root",
    searchForm: "discovery-search-form",
    searchIndustry: "discovery-search-industry",
    searchCountry: "discovery-search-country",
    searchState: "discovery-search-state",
    searchCity: "discovery-search-city",
    searchButton: "discovery-search-button",
    listFilterInput: "discovery-list-filter-input",
    listFilterValidation: "discovery-list-filter-validation",
    toggleArchived: "discovery-toggle-archived",
    refreshList: "discovery-refresh-list",
    card: "discovery-card",
    detailDrawer: "discovery-detail-drawer",
    actionConvert: "discovery-action-convert",
    actionEmail: "discovery-action-email",
    actionEnrichAi: "discovery-action-enrich-ai",
    actionRecrawl: "discovery-action-recrawl",
    actionArchive: "discovery-action-archive",
    actionDelete: "discovery-action-delete",
    tagInput: "discovery-tag-input",
    tagAdd: "discovery-tag-add",
};
